module.exports = __webpack_public_path__ + "img/hourglass.483aff1b.gif";